import styled from 'styled-components';

export const Container = styled.div`
  position: fixed;
  inset: 0;
  z-index: 120;
  background-color: var(--color-white);
`;

export const CloseButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  inset: 10px 10px auto auto;
  z-index: 1;
  height: 50px;
  width: 50px;
  cursor: pointer;
`;

export const Scroll = styled.div`
  height: 100%;
  overflow: auto;
  padding: 90px 20px 20px;
  @media (max-width: 991px) {
    padding: 90px 10px 10px;
  }
`;
